import React, { useState, useEffect, useRef } from "react";
import {
  Input,
  Row,
  Col,
  Divider,
  Popover,
  Tag,
  Button,
  Badge,
  Checkbox,
  Drawer,
  Form,
  Dropdown,
  Space,
  Skeleton,
  Modal,
  Radio,
  InputNumber,
  DatePicker,
  Select,
  Card,
  message,
} from "antd";
import "swiper/swiper-bundle.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";

import moment from "moment";
import "../../css/custom.css";
import styles from "./BookingDetails.module.css";
import ViewCart from "./ViewCart";
import {
  getAllRateDateWise,
  checkRoomAvailblity,
} from "../../redux/HomePage/actionCreater";
import { useDispatch } from "react-redux";
import Customer from "./customer";
import { getRoomNightRate, withDisplayTax } from "./roomPricing";
import { guestsLabel } from "./guestParams";
import { criticalPath, LOADING_INDICATOR } from "./hotelAdsMarkup";
import { AmenityList, RoomAbout, SeeMoreToggle } from "./RoomAmenities";

// amenities shown on a room card before "See more"
const CARD_AMENITY_LIMIT = 6;

// Default to 1 adult unless the room type provides a different default.
const DEFAULT_ADULT = 1;

function BookingDetails({
  roomType,
  rsSymbol,
  currentRegisterData,
  shopDetails,
  reservationStartDate,
  reservationEndDate,
  rateDateWiseObj,
  cancelPolicy,
  setReservationData,
  reservationData,
  setShowBill1,
  showBill1,
  paymentType,
  currency,
  custom_payment,
  color,
  price_adjustment,
  percentage_adjustment,
  privacyPolicy,
  termCondtion,
  searchAdults,
  searchChildren,
  onClearGuests,
}) {
  const [isFeatured, setIsFeatured] = useState(false);
  const [rooms, setRooms] = useState([{ adults: 1, children: 0, infants: 0 }]); // Initial room
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [selectedRoomIndex, setSelectedRoomIndex] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [modalTitle, setModalTitle] = useState("");
  const [modalAmenities, setModalAmenities] = useState([]);
  const [modalRoomDescription, setModalRoomDescription] = useState();
  const swiperRef = useRef(null);
  const roomListRef = useRef(null);
  // Desktop room cards: the photo is as tall as the card's details column
  // (so it grows when rooms / guest rows are added) but NOT counting what
  // "See more" reveals. Sets --card-img-h on each card; CSS uses it >= 992px.
  useEffect(() => {
    const root = roomListRef.current;
    if (!root || typeof ResizeObserver === "undefined") return undefined;
    const update = (details) => {
      const card = details.closest(`.${styles.cardDetails}`);
      if (!card) return;
      const extra = details.querySelector(`.${styles.cardExtra}`);
      const extraHeight = extra ? extra.getBoundingClientRect().height : 0;
      const height = details.getBoundingClientRect().height - extraHeight;
      card.style.setProperty("--card-img-h", `${Math.round(height)}px`);
    };
    const observer = new ResizeObserver((entries) =>
      entries.forEach((entry) => update(entry.target)),
    );
    root
      .querySelectorAll(`.${styles.cardAllDetails}`)
      .forEach((details) => observer.observe(details));
    return () => observer.disconnect();
  });

  const [numberOfNights, setNumberOfNights] = useState(
    moment(reservationEndDate).diff(moment(reservationStartDate), "days"),
  );
  const [stayForm] = Form.useForm();
  // const [rateDateWiseObj, setRateDatewiseRateObj] = useState({});
  let [selectedRoomtype, setSelectedRoomType] = useState([]);
  const [showBill, setShowBill] = useState(false);
  const [overBookingModal, setOverBookingModal] = useState(false);
  const [unavailableRoomIndex, setUnavailableRoomIndex] = useState(null);
  const [load, setLoad] = useState(true);
  const fetchDateWiseRate1 = async () => {
    let startDate = moment(reservationStartDate).format("MM/DD/YYYY");
    let endDate = moment(reservationEndDate)
      .subtract(1, "days")
      .format("MM/DD/YYYY");
    const getRateList = await dispatch(
      getAllRateDateWise(currentRegisterData?._id, {
        startDate: startDate,
        endDate: endDate,
      }),
    );
    if (getRateList && getRateList.data) {
      let obj = {};
      getRateList.data.map((k) => {
        obj[`${moment(k.date).format("MM/DD/YYYY")}-${k.rate_id}`] = k;
      });
      return obj;
    }
  };
  const [windowWidth, setWindowWidth] = useState(
    window.innerWidth > 0 ? window.innerWidth : window.outerWidth,
  );
  const openModal = (amenities, roomIndex, imageIndex, title, decsription) => {
    setSelectedRoomIndex(roomIndex);
    setModalAmenities(amenities);
    setSelectedImageIndex(imageIndex);
    setModalTitle(title);
    setModalRoomDescription(decsription);
    setVisible(true);
  };

  const closeModal = () => {
    setVisible(false);
  };

  const handlePrevInModal = (currentImageIndex, roomIndex, imageCount) => {
    const prevIndex = (currentImageIndex - 1 + imageCount) % imageCount;
    setSelectedImageIndex(prevIndex);
  };

  const handleNextInModal = (currentImageIndex, roomIndex, imageCount) => {
    const nextIndex = (currentImageIndex + 1) % imageCount;
    setSelectedImageIndex(nextIndex);
  };
  useEffect(() => {
    setWindowWidth(
      window.innerWidth > 0 ? window.innerWidth : window.outerWidth,
    );
  }, [window.innerWidth > 0 ? window.innerWidth : window.outerWidth]);
  let [customerData, setCustomerData] = useState({
    name: "",
    mobile: "",
    shipping_address: "",
    email: "",
    additional: "",
  });
  const createPriceAdjustment = (calculatedRate) => {
    if (price_adjustment == "decrease" && percentage_adjustment != "") {
      calculatedRate =
        calculatedRate - (calculatedRate * percentage_adjustment) / 100;
      return calculatedRate;
    } else if (price_adjustment == "increase" && percentage_adjustment != "") {
      calculatedRate =
        calculatedRate + (calculatedRate * percentage_adjustment) / 100;
      return calculatedRate;
    } else {
      return calculatedRate;
    }
  };
  const onSelectRatePlan = (ratePlanInput, rateDateWiseObj) => {
    // Clone the input so the base roomType prop is never mutated. Every date
    // change must start from the original data and re-apply overrides fresh.
    let ratePlan = {
      ...ratePlanInput,
      adult_rates: ratePlanInput?.adult_rates?.map((j) => ({ ...j })),
    };
    let default_adult_rate = 0;
    let extra_adult_rate = 0;
    let extra_child_rate = 0;
    let extra_infant_rate = 0;
    const currentDate = new Date(reservationStartDate);
    const endDate = new Date(reservationEndDate);

    ratePlan?.adult_rates?.forEach((j) => {
      let myRate = 0;
      const currentDate1 = new Date(reservationStartDate);
      const endDate1 = new Date(reservationEndDate);
      const baseRate = Number(j.rate);
      while (currentDate1 < endDate1) {
        let thatDay = currentDate1.toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        });

        if (
          rateDateWiseObj &&
          ratePlan &&
          ratePlan.rate_id &&
          rateDateWiseObj[`${thatDay}-${ratePlan.rate_id}`]
        ) {
          let latestObj =
            rateDateWiseObj[`${thatDay}-${ratePlan.rate_id}`]?.value;
          // rate/list stores per-occupancy adult prices under
          // `default_adult1`, `default_adult2`, ... matching numberOfAdult.
          // default_adult_rate
          let overrideKey = `default_adult${j.numberOfAdult}`;
          // let overrideKey = `default_adult_rate`;
          if (
            latestObj[overrideKey] != undefined &&
            latestObj[overrideKey] !== ""
          ) {
            myRate += Number(latestObj[overrideKey]);
          } else {
            myRate += baseRate;
          }
        } else {
          myRate += baseRate;
        }

        currentDate1.setDate(currentDate1.getDate() + 1);
      }
      let calculatedRate = createPriceAdjustment(myRate / numberOfNights);

      j.rate = calculatedRate.toString();
    });
    while (currentDate < endDate) {
      let thatDay = currentDate.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });

      if (
        rateDateWiseObj &&
        ratePlan &&
        ratePlan.rate_id &&
        rateDateWiseObj[`${thatDay}-${ratePlan.rate_id}`]
      ) {
        let latestObj =
          rateDateWiseObj[`${thatDay}-${ratePlan.rate_id}`]?.value;
        default_adult_rate += Number(
          latestObj.default_adult_rate != undefined
            ? latestObj.default_adult_rate
            : ratePlan?.default_adult_rate,
        );
        extra_adult_rate += Number(
          latestObj.extra_adult_rate != undefined
            ? latestObj.extra_adult_rate
            : ratePlan.extra_adult_rate,
        );
        extra_child_rate += Number(
          latestObj.extra_child_rate != undefined
            ? latestObj.extra_child_rate
            : ratePlan?.extra_child_rate,
        );
        extra_infant_rate += Number(
          latestObj.extra_infant_rate != undefined
            ? latestObj.extra_infant_rate
            : ratePlan?.extra_infant_rate,
        );
      } else {
        default_adult_rate += Number(ratePlan.default_adult_rate);
        extra_adult_rate += Number(ratePlan.extra_adult_rate);
        extra_child_rate += Number(ratePlan.extra_child_rate);
        extra_infant_rate += Number(ratePlan.extra_infant_rate);
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
    let calCulatedDefaultRate = createPriceAdjustment(
      default_adult_rate / numberOfNights,
    );
    let calCulatedExtraAdultRate = createPriceAdjustment(
      extra_adult_rate / numberOfNights,
    );
    let calCulatedExtraChildRate = createPriceAdjustment(
      extra_child_rate / numberOfNights,
    );
    let calCulatedExtraInfantRate = createPriceAdjustment(
      extra_infant_rate / numberOfNights,
    );

    ratePlan = {
      ...ratePlan,
      default_adult_rate: calCulatedDefaultRate.toString(),
      extra_adult_rate: calCulatedExtraAdultRate.toString(),
      extra_child_rate: calCulatedExtraChildRate.toString(),
      extra_infant_rate: calCulatedExtraInfantRate.toString(),
    };
    return ratePlan;
  };

  // "Show all rooms" escape hatch for searches bigger than any single room
  const [showAllRooms, setShowAllRooms] = useState(false);
  // room capacity from the room type; missing / 0 means "no limit"
  const getRoomCapacity = (roomTypeRow) => {
    const maxAdults = Number(roomTypeRow?.original_room_type?.max_adult);
    const maxChildren = Number(roomTypeRow?.original_room_type?.max_children);
    return {
      maxAdults: maxAdults > 0 ? maxAdults : Infinity,
      maxChildren: maxChildren >= 0 ? maxChildren : Infinity,
    };
  };
  // guests one room of this type would hold for the current search
  const getSearchOccupancy = (roomTypeRow) => {
    const { maxAdults, maxChildren } = getRoomCapacity(roomTypeRow);
    const wantedAdults =
      Number(searchAdults) ||
      Number(roomTypeRow?.room_type?.default_adult) ||
      DEFAULT_ADULT;
    const wantedChildren = Number(searchChildren) || 0;
    return {
      adults: Math.min(wantedAdults, maxAdults),
      children: Math.min(wantedChildren, maxChildren),
      infants: 0,
      isCapped: wantedAdults > maxAdults || wantedChildren > maxChildren,
    };
  };
  // card price = per-night price for the searched guests (same formula as cart)
  // true only when the booking URL carried ?adults / ?children
  const hasGuestSearch = Number(searchAdults) > 0 || Number(searchChildren) > 0;
  // card price, in priority order:
  //  1. rooms added on this card -> their per-night total, so the card always
  //     matches Booking Details as Adult / Children / Infants +/- change
  //  2. guest search in the URL -> per-night price for those guests
  //  3. otherwise the room type's default-occupancy rate, as before
  const getDisplayRate = (val) => {
    if (val?.rooms?.length) {
      const selectedTotal = val.rooms.reduce(
        (sum, room) => sum + getRoomNightRate(val, room),
        0,
      );
      return withDisplayTax(selectedTotal, val?.room_type?.tax_group);
    }
    if (hasGuestSearch) {
      return withDisplayTax(
        getRoomNightRate(val, getSearchOccupancy(val)),
        val?.room_type?.tax_group,
      );
    }
    // no room added yet: show the rate plan's default_adult_rate
    // (date-wise rate/list override already applied by onSelectRatePlan)
    return withDisplayTax(
      val?.rate_plan?.default_adult_rate ?? 0,
      val?.room_type?.tax_group,
    );
  };

  // room list order: available rooms first, cheapest to costliest by the
  // price shown on the card; sold-out rooms go to the bottom (also by price)
  const sortRoomList = (rows) =>
    [...rows].sort((a, b) => {
      if (Boolean(a?.isAvailable) !== Boolean(b?.isAvailable)) {
        return a?.isAvailable ? -1 : 1;
      }
      return (
        getDisplayRate({ ...a, rooms: [] }) -
        getDisplayRate({ ...b, rooms: [] })
      );
    });

  // caption under the card price, describing what that price is for
  const getPriceCaption = (val) => {
    if (val?.rooms?.length) {
      const total = (key) =>
        val.rooms.reduce((sum, room) => sum + (Number(room?.[key]) || 0), 0);
      const guests = guestsLabel(
        total("adults"),
        total("children"),
        total("infants"),
      );
      return val.rooms.length === 1
        ? `for ${guests}`
        : `${val.rooms.length} rooms · ${guests}`;
    }
    if (hasGuestSearch) {
      const occupancy = getSearchOccupancy(val);
      return `${occupancy.isCapped ? "per room, max " : "for "}${guestsLabel(
        occupancy.adults,
        occupancy.children,
      )}`;
    }
    return null;
  };

  // nights of the picked stay; the checkout date is not a night, so a 12-13 stay
  // only needs a room on the 12th
  const getStayNights = () => {
    const nights = [];
    const night = moment(reservationStartDate);
    while (night.isBefore(moment(reservationEndDate), "day")) {
      nights.push(night.format("MM/DD/YYYY"));
      night.add(1, "days");
    }
    return nights;
  };
  // same check as the PMS reservation screen: lowest daily sell limit of the
  // stay minus rooms booked. The pmsInfo flag can count the checkout date, so
  // it is only the fallback when check-availability gives no answer.
  const isRoomTypeSoldOut = async (roomTypeRow, stayNights) => {
    let sellQty = Number(roomTypeRow?.numberOfRooms) || 0;
    const rateId = roomTypeRow?.rate_plan?.[0]?.rate_id;
    stayNights.forEach((night) => {
      const sell = rateDateWiseObj?.[`${night}-${rateId}`]?.value?.sell;
      if (
        sell !== undefined &&
        sell !== null &&
        sell !== "" &&
        Number(sell) < sellQty
      ) {
        sellQty = Number(sell);
      }
    });
    const response = await dispatch(
      checkRoomAvailblity({
        reservationStartDate: moment(reservationStartDate).format("YYYY-MM-DD"),
        reservationEndDate: moment(reservationEndDate)
          .subtract(1, "days")
          .format("YYYY-MM-DD"),
        roomTypeId: roomTypeRow?._id,
        needRoom: 0,
        totalRoom: sellQty,
      }),
    );
    const available = response?.data?.avilableRoom;
    if (available === undefined || available === null) {
      return roomTypeRow?.isAvailable === false;
    }
    return Number(available) <= 0;
  };

  // ignore late availability responses of an older date selection
  const roomListRequestRef = useRef(0);
  useEffect(() => {
    setLoad(true);
    const requestId = ++roomListRequestRef.current;
    let array = [];
    setNumberOfNights(
      moment(reservationEndDate).diff(moment(reservationStartDate), "days"),
    );

    const originalRoomData = roomType ? structuredClone(roomType) : [];
    const stayNights = getStayNights();

    const unavailableRoomTypeIds = new Set();
    if (rateDateWiseObj) {
      Object.values(rateDateWiseObj).forEach((row) => {
        if (
          row &&
          row.isAvailable === false &&
          row.room_type_id &&
          stayNights.includes(moment(row.date).format("MM/DD/YYYY"))
        ) {
          unavailableRoomTypeIds.add(row.room_type_id);
        }
      });
    }

    const buildRoomList = async () => {
      const soldOutFlags = await Promise.all(
        originalRoomData.map((val) => isRoomTypeSoldOut(val, stayNights)),
      );
      if (requestId !== roomListRequestRef.current) return;

      originalRoomData.map((val, roomTypeIndex) => {
        val.rate_plan.map((rate) => {
          if (
            rate.show_booking_engine ||
            rate?.show_booking_engine == undefined
          ) {
            // Default available; sold out when any night of the stay has no
            // room left, or when a rate/list row blocks one of those nights.
            let isAvailable =
              !soldOutFlags[roomTypeIndex] &&
              !unavailableRoomTypeIds.has(val._id);
            let myObj = {
              room_type: {
                _id: val._id,
                name: val.name,
                default_adult: val.default_adult,
                default_children: val.default_children,
                default_infant: val.default_infant,
                tax_group: val.tax_group,
                rate_plan_list: val.rate_plan,
                numberOfRooms: [...Array(val.numberOfRooms)],
                firstTimeSelect: true,
              },
              rate_plan: onSelectRatePlan(rate, rateDateWiseObj),
              numberOfRooms: 0,
              rooms: [],
              total_guest: 1,
              calculatedPriceWithoutTax: 0,
              calCulatedTaxPrice: 0,
              calculatedPriceWithTax: 0,
              roomTypeId: val._id,
              isAvailable: isAvailable,
              isManualPricing: false,
              original_room_type: val,
              is_more: false,
              image_index: 0,
            };
            if (
              currentRegisterData?.connect_channel &&
              currentRegisterData?.channel_key != "" &&
              roomType?.channel_room_code != ""
            ) {
              myObj["room_type"]["channel_room_code"] = val?.channel_room_code;
              myObj["room_type"]["channel_room_name"] = val?.channel_room_name;
            }
            array.push(myObj);
          }
        });
      });
      setSelectedRoomType(sortRoomList(array));
      setLoad(false);
    };
    buildRoomList();
  }, [rateDateWiseObj, roomType]);
  const toggleFeatured = (is_more, index) => {
    let newroomType = selectedRoomtype;
    newroomType[index]["is_more"] = !is_more;
    setSelectedRoomType([...newroomType]);
  };
  const handleNext = (image_index, mainIndex, totalImage) => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext();
    }
    // if (totalImage == image_index + 1) {
    //   selectedRoomtype[mainIndex]["image_index"] = 0;
    //   setSelectedRoomType([...selectedRoomtype]);
    // } else {
    //   selectedRoomtype[mainIndex]["image_index"] = image_index + 1;
    //   setSelectedRoomType([...selectedRoomtype]);
    // }
  };
  const handlePrev = (image_index, mainIndex, totalImage) => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slidePrev();
    }
    // if (image_index > 0) {
    //   selectedRoomtype[mainIndex]["image_index"] = image_index - 1;
    //   setSelectedRoomType([...selectedRoomtype]);
    // } else {
    //   selectedRoomtype[mainIndex]["image_index"] = totalImage - 1;
    //   setSelectedRoomType([...selectedRoomtype]);
    // }
  };
  const addRoom = () => {
    setRooms([...rooms, { adults: 1, children: 0, infants: 0 }]);
  };

  // Function to handle removing the last room
  const removeRoom = () => {
    if (rooms.length > 1) {
      setRooms(rooms.slice(0, -1)); // Remove the last room
    }
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [showBill]);

  const updateRoom = (index, key, value) => {
    const updatedRooms = [...rooms];
    updatedRooms[index][key] = value;
    setRooms(updatedRooms);
  };

  const [reservationDisable, setReservationDisable] = useState(false);
  const closeOverBookingModal = () => {
    setUnavailableRoomIndex(null);
    setReservationDisable(false);
    setOverBookingModal(false);
  };
  const checkRoomAvailble = async (
    reservationStartDate,
    reservationEndDate,
    room,
    roomTypeData,
    noRoom,
    roomTypeIndex,
  ) => {
    setReservationDisable(true);
    let startDate = moment(reservationStartDate).format("YYYY-MM-DD");
    let endDate = moment(reservationEndDate)
      .subtract(1, "days")
      .format("YYYY-MM-DD");
    let sellQty =
      noRoom != undefined ? noRoom : roomTypeData?.numberOfRooms?.length;
    if (currentRegisterData && currentRegisterData._id) {
      let dateObj = await fetchDateWiseRate1();
      let startDate1 = moment(reservationStartDate);
      let endDate1 = moment(reservationEndDate);
      while (moment(startDate1).isBefore(endDate1)) {
        let rate_id = roomTypeData?.rate_plan
          ? roomTypeData?.rate_plan[0]?.rate_id
          : roomTypeData?.rate_plan_list[0]?.rate_id;
        if (dateObj[`${moment(startDate1).format("MM/DD/YYYY")}-${rate_id}`]) {
          let thisObj =
            dateObj[`${moment(startDate1).format("MM/DD/YYYY")}-${rate_id}`];
          if (thisObj?.value?.sell && thisObj?.value?.sell != "") {
            if (Number(thisObj?.value?.sell) < sellQty) {
              sellQty = Number(thisObj?.value?.sell);
            }
          }
        }
        startDate1 = moment(startDate1).add(1, "days");
      }
    }
    let response = await dispatch(
      checkRoomAvailblity({
        reservationStartDate: startDate,
        reservationEndDate: endDate,
        roomTypeId: roomTypeData?._id,
        needRoom: room,
        totalRoom: sellQty,
      }),
    );
    if (response && response.data) {
      if (response.data.avilableStatus == false) {
        setUnavailableRoomIndex(roomTypeIndex);
        setOverBookingModal(true);
        setReservationDisable(true);
        return true;
      } else {
        setReservationDisable(false);
        return false;
      }
    }
  };
  function createArrayOfObjects(dataCount, roomObject) {
    const arrayOfObjects = [];
    for (let i = 1; i <= dataCount; i++) {
      const object = {
        adults: Number(roomObject?.adults) || DEFAULT_ADULT,
        children: Number(roomObject?.children) || 0,
        infants: 0,
      };
      arrayOfObjects.push(object);
    }
    return arrayOfObjects;
  }
  function removeArrayOfObjects(originalArray, x) {
    const newArray = originalArray.slice(0, x);
    return newArray;
  }

  const handleArray = (x, array, roomObject) => {
    if (array.length < x) {
      let checkPush = x - array.length;
      let newArray = createArrayOfObjects(checkPush, roomObject);
      array = [...array, ...newArray];
      return array;
    } else if (array.length > x) {
      return removeArrayOfObjects(array, x);
    }
  };
  const onSelectRoomNo = async (no, index, array, roomObject, type) => {
    if (reservationDisable && type == "add") {
      message.error(
        "Please remove the first unavailable room after adding a new room.",
      );
      return true;
    }
    if (type == "add") {
      const isUnavailable = await checkRoomAvailble(
        reservationStartDate,
        reservationEndDate,
        no,
        selectedRoomtype[index]?.room_type,
        undefined,
        index,
      );
      if (isUnavailable) {
        return true;
      }
    }
    selectedRoomtype[index]["rooms"] = handleArray(no, array, roomObject);
    selectedRoomtype[index]["numberOfRooms"] = no;
    if (type != "add") {
      checkRoomAvailble(
        reservationStartDate,
        reservationEndDate,
        no,
        selectedRoomtype[index]?.room_type,
        undefined,
        index,
      );
    }
    setSelectedRoomType([...selectedRoomtype]);
  };
  // remove a room type from Booking Details: same path as pressing "-" on the
  // card down to 0, so the card shows "Add Room" again and availability is
  // re-checked. Rows are matched by object, else room type + rate plan.
  const removeRoomTypeFromCart = (row) => {
    let index = selectedRoomtype.indexOf(row);
    if (index < 0) {
      index = selectedRoomtype.findIndex(
        (r) =>
          r?.roomTypeId === row?.roomTypeId &&
          r?.rate_plan?.rate_id === row?.rate_plan?.rate_id,
      );
    }
    if (index < 0 || !selectedRoomtype[index]?.rooms?.length) return;
    onSelectRoomNo(0, index, selectedRoomtype[index].rooms, {}, "remove");
  };
  // guests per room from the booking URL (?adults=N&children=N); 0 = not set
  const requestedAdults = Number(searchAdults) || 0;
  const requestedChildren = Number(searchChildren) || 0;
  const selectedRoomCount = (selectedRoomtype || []).reduce(
    (total, roomTypeRow) => total + (roomTypeRow?.rooms?.length || 0),
    0,
  );

  // room types that can't hold the searched guests in one room are hidden,
  // unless already in the cart or the guest chose "Show all rooms"
  const fitsSearch = (roomTypeRow) => {
    const { maxAdults, maxChildren } = getRoomCapacity(roomTypeRow);
    return requestedAdults <= maxAdults && requestedChildren <= maxChildren;
  };
  const isRoomVisible = (roomTypeRow) =>
    showAllRooms || roomTypeRow?.numberOfRooms > 0 || fitsSearch(roomTypeRow);
  const listedRoomTypes = (selectedRoomtype || []).filter(
    (row) => row?.original_room_type,
  );
  const hiddenRoomCount = listedRoomTypes.filter(
    (row) => !isRoomVisible(row),
  ).length;
  const visibleRoomCount = listedRoomTypes.length - hiddenRoomCount;
  const fittingRoomCount = listedRoomTypes.filter(fitsSearch).length;
  useEffect(() => {
    setShowAllRooms(false);
    // card prices follow the guest search, so keep the low-to-high order
    setSelectedRoomType((rows) => sortRoomList(rows));
  }, [requestedAdults, requestedChildren]);
  // every added room starts with the URL guests (capped by room capacity);
  // without them the room type's default occupancy is used, as before
  const getNewRoomGuests = (roomTypeRow) => {
    const { maxAdults, maxChildren } = getRoomCapacity(roomTypeRow);
    const defaultAdults =
      Number(roomTypeRow?.room_type?.default_adult) || DEFAULT_ADULT;
    return {
      adults: Math.min(requestedAdults || defaultAdults, maxAdults),
      children: Math.min(requestedChildren, maxChildren),
    };
  };

  // Clear: drop the URL guest filter and put every selected room back to its
  // room type's default occupancy (default adults, no children)
  const clearGuestFilter = () => {
    setSelectedRoomType((rows) =>
      rows.map((row) => {
        if (!row?.rooms?.length) return row;
        const { maxAdults } = getRoomCapacity(row);
        const defaultAdults = Math.min(
          Number(row?.room_type?.default_adult) || DEFAULT_ADULT,
          maxAdults,
        );
        return {
          ...row,
          rooms: row.rooms.map((room) => ({
            ...room,
            adults: defaultAdults,
            children: 0,
          })),
        };
      }),
    );
    onClearGuests();
  };

  const updateGuest = (roomTypeIndex, roomIndex, guestType, checkPlusMinus) => {
    const removeEmptyRoom = () => {
      const nextRoomTypes = [...selectedRoomtype];
      const nextRooms = [...(nextRoomTypes[roomTypeIndex]?.rooms || [])];
      nextRooms.splice(roomIndex, 1);
      nextRoomTypes[roomTypeIndex].rooms = nextRooms;
      nextRoomTypes[roomTypeIndex].numberOfRooms = nextRooms.length;
      setSelectedRoomType(nextRoomTypes);
    };

    if (checkPlusMinus == "plus") {
      let updateNumber =
        1 + selectedRoomtype[roomTypeIndex].rooms[roomIndex][guestType];
      if (
        guestType == "adults" &&
        updateNumber >
          selectedRoomtype[roomTypeIndex]?.original_room_type?.max_adult
      ) {
        message.error("Guest limit exceeded.");
        return true;
      }
      if (
        guestType == "children" &&
        updateNumber >
          selectedRoomtype[roomTypeIndex]?.original_room_type?.max_children
      ) {
        message.error("Guest limit exceeded.");
        return true;
      }
      if (
        guestType == "infants" &&
        updateNumber >
          selectedRoomtype[roomTypeIndex]?.original_room_type?.max_infant
      ) {
        message.error("Guest limit exceeded.");
        return true;
      }
      selectedRoomtype[roomTypeIndex].rooms[roomIndex][guestType] =
        ++selectedRoomtype[roomTypeIndex].rooms[roomIndex][guestType];

      setSelectedRoomType([...selectedRoomtype]);
      return selectedRoomtype;
    } else {
      if (selectedRoomtype[roomTypeIndex].rooms[roomIndex][guestType] > 0) {
        selectedRoomtype[roomTypeIndex].rooms[roomIndex][guestType] =
          --selectedRoomtype[roomTypeIndex].rooms[roomIndex][guestType];

        const currentRoom = selectedRoomtype[roomTypeIndex].rooms[roomIndex];
        const isRoomEmpty =
          Number(currentRoom?.adults || 0) === 0 &&
          Number(currentRoom?.children || 0) === 0 &&
          Number(currentRoom?.infants || 0) === 0;

        if (isRoomEmpty) {
          removeEmptyRoom();
          return selectedRoomtype;
        }

        setSelectedRoomType([...selectedRoomtype]);
        return selectedRoomtype;
      } else {
        setSelectedRoomType([...selectedRoomtype]);
        return selectedRoomtype;
      }
    }
  };

  if (load) {
    return (
      <div className={styles.SkeletonContainer} {...LOADING_INDICATOR}>
        <Skeleton title width={150} active={true} />
        <br />
        <br />
        <div className={styles.cardSkeleton}>
          <Skeleton paragraph={{ rows: 3 }} active={true} />
          <Skeleton.Image active={true} />
        </div>
        <br />
        <div className={styles.cardSkeleton}>
          <Skeleton paragraph={{ rows: 3 }} active={true} />
          <Skeleton.Image active={true} />
        </div>
        <br />
        <div className={styles.cardSkeleton}>
          <Skeleton paragraph={{ rows: 3 }} active={true} />
          <Skeleton.Image active={true} />
        </div>
        <Space>
          <Skeleton.Button active={true} size="large" />
          <Skeleton.Input active={true} />
        </Space>
      </div>
    );
  }

  // Cart column only exists once at least one room is added. Removing the last
  // room hides it again and the room list expands to the full row width.
  const hasSelectedRooms = selectedRoomtype?.some(
    (val) => val.numberOfRooms > 0,
  );
  // Once a room is in the cart its next click is Proceed instead.
  const crawlerRoomIndex = hasSelectedRooms
    ? -1
    : (selectedRoomtype || []).findIndex(
        (val) =>
          val?.original_room_type &&
          isRoomVisible(val) &&
          val?.isAvailable !== false,
      );

  return (
    <div>
      <section className={styles.detailSection}>
        <div className="container">
          <div className="row">
            <div
              className={`col-12 col-md-12 ${
                hasSelectedRooms ? "col-lg-8" : "col-lg-12"
              } d-flex flex-column gap-3 ${styles.cardScroller}`}
              ref={roomListRef}
            >
              {showBill ? (
                <div>
                  {windowWidth > 1024 && (
                    <Customer
                      setCustomerData={setCustomerData}
                      customerData={customerData}
                      cancelPolicy={cancelPolicy}
                      privacyPolicy={privacyPolicy}
                      termCondtion={termCondtion}
                    />
                  )}
                </div>
              ) : (
                <div>
                  {requestedAdults > 0 && (
                    <div
                      className={`${styles.guestSummary} ${
                        selectedRoomCount > 0 ? styles.guestSummaryDone : ""
                      }`}
                      style={{ "--text-color": color }}
                    >
                      <i class="fa-solid fa-user-group"></i>
                      <p>
                        Booking for{" "}
                        <strong>
                          {guestsLabel(requestedAdults, requestedChildren)}
                        </strong>{" "}
                        per room
                        {" · "}
                        {selectedRoomCount > 0
                          ? `${selectedRoomCount} ${
                              selectedRoomCount === 1 ? "room" : "rooms"
                            } selected.`
                          : visibleRoomCount === 0
                            ? "No single room fits these guests."
                            : "Add a room below to get started."}
                      </p>
                      {onClearGuests && (
                        <button
                          type="button"
                          className={styles.guestClearBtn}
                          onClick={clearGuestFilter}
                        >
                          Clear
                        </button>
                      )}
                    </div>
                  )}
                  {console.log("selectedRoomtype", selectedRoomtype)}
                  {selectedRoomtype?.map((val, index) => {
                    let singleRoomType = val.original_room_type;
                    if (singleRoomType && isRoomVisible(val)) {
                      return (
                        <div>
                          {" "}
                          <div
                            className={`${styles.cardDetails} ${
                              hasSelectedRooms ? "" : styles.wideCard
                            }`}
                          >
                            <div className="row align-items-center align-items-lg-stretch">
                              {singleRoomType?.room_images?.length > 0 && (
                                <div
                                  className={`col-12 col-md-5 ${
                                    hasSelectedRooms ? "" : "col-lg-4"
                                  } ${styles.cardImageCol}`}
                                >
                                  <div className="carousel slide">
                                    <div
                                      id="carouselExample"
                                      className="carousel slide"
                                      data-ride="carousel"
                                    >
                                      <div className="carousel-inner d-flex align-items-center">
                                        <div
                                          className={`d-flex justify-content-between py-4 ${styles.setBtnDiv}`}
                                        ></div>
                                        <Swiper
                                          navigation={true}
                                          modules={[Pagination, Navigation]}
                                          loop={true}
                                          pagination={{ clickable: true }}
                                          slidesPerView={1}
                                          className="myDetailsSwiper"
                                          ref={swiperRef}
                                        >
                                          {singleRoomType?.room_images?.map(
                                            (item, i) => {
                                              return (
                                                <SwiperSlide key={i}>
                                                  {/* {item.url} */}
                                                  <img
                                                    className={`d-block ${styles.itemCarouselImg} `}
                                                    src={item.url}
                                                    alt=""
                                                    onClick={() =>
                                                      openModal(
                                                        singleRoomType?.room_ammenties,
                                                        index,
                                                        i,
                                                        `${singleRoomType?.name} ${val?.rate_plan?.rate_name}`,
                                                        singleRoomType?.summary_of_roomtype,
                                                      )
                                                    }
                                                  />
                                                </SwiperSlide>
                                              );
                                            },
                                          )}
                                        </Swiper>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              <div
                                className={`col-12 ${
                                  singleRoomType?.room_images?.length > 0
                                    ? `col-md-7 ${
                                        hasSelectedRooms ? "" : "col-lg-8"
                                      }`
                                    : "col-md-12"
                                }`}
                              >
                                <div className={styles.cardAllDetails}>
                                  <div className="d-flex justify-content-between">
                                    <div className={styles.roomTitle}>
                                      <label>
                                        {singleRoomType?.name}
                                        {val?.rate_plan?.rate_name && (
                                          <span className={styles.ratePlan}>
                                            {val.rate_plan.rate_name}
                                          </span>
                                        )}
                                      </label>
                                      {/* {Number(singleRoomType?.max_adult) >
                                        0 && (
                                        <small
                                          className={styles.roomCapacity}
                                        >
                                          <i class="fa-solid fa-user"></i>{" "}
                                          Up to{" "}
                                          {guestsLabel(
                                            Number(singleRoomType.max_adult),
                                            Number(
                                              singleRoomType.max_children,
                                            ) || 0,
                                          )}{" "}
                                          per room
                                        </small>
                                      )} */}
                                    </div>
                                    <div
                                      className={`d-flex flex-column ${styles.priceBlock}`}
                                    >
                                      <h2>
                                        {rsSymbol}
                                        {getDisplayRate(val)}
                                        <span>/ Night</span>
                                      </h2>
                                      {getPriceCaption(val) && (
                                        <small className={styles.priceFor}>
                                          {getPriceCaption(val)}
                                        </small>
                                      )}
                                      <small className={styles.taxNote}>
                                        {"Inclusive Taxes"}
                                      </small>
                                    </div>
                                  </div>
                                  <hr />
                                  {(() => {
                                    const amenities =
                                      singleRoomType?.room_ammenties || [];
                                    const hasDescription = !!String(
                                      singleRoomType?.summary_of_roomtype || "",
                                    ).trim();
                                    const extraCount = Math.max(
                                      amenities.length - CARD_AMENITY_LIMIT,
                                      0,
                                    );
                                    // toggle only when there is more to show
                                    const canExpand =
                                      extraCount > 0 || hasDescription;
                                    return (
                                      <>
                                        <AmenityList
                                          amenities={amenities.slice(
                                            0,
                                            CARD_AMENITY_LIMIT,
                                          )}
                                          color={color}
                                          className={styles.cardAmenities}
                                        />
                                        {/* everything "See more" reveals sits in
                                            one block, so the photo height can
                                            leave it out (see cardExtra effect) */}
                                        {val.is_more && canExpand && (
                                          <div className={styles.cardExtra}>
                                            {extraCount > 0 && (
                                              <AmenityList
                                                amenities={amenities.slice(
                                                  CARD_AMENITY_LIMIT,
                                                )}
                                                color={color}
                                                className={styles.cardAmenities}
                                              />
                                            )}
                                            <RoomAbout
                                              text={
                                                singleRoomType?.summary_of_roomtype
                                              }
                                              color={color}
                                            />
                                          </div>
                                        )}
                                        {canExpand && (
                                          <SeeMoreToggle
                                            expanded={!!val.is_more}
                                            extraCount={extraCount}
                                            onClick={() =>
                                              toggleFeatured(val.is_more, index)
                                            }
                                          />
                                        )}
                                      </>
                                    );
                                  })()}
                                  <div>
                                    {val.numberOfRooms ? (
                                      <div>
                                        <div className={styles.roomsAdd}>
                                          <a
                                            onClick={() => {
                                              onSelectRoomNo(
                                                val.numberOfRooms - 1,
                                                index,
                                                val.rooms,
                                                {
                                                  adults:
                                                    val?.room_type
                                                      ?.default_adult,
                                                  children:
                                                    val?.room_type
                                                      ?.default_children,
                                                  infants:
                                                    val?.room_type
                                                      ?.default_infant,
                                                },
                                                "minus",
                                              );
                                            }}
                                          >
                                            <i class="fa-solid fa-minus"></i>
                                          </a>
                                          <div>
                                            {val.rooms.length == 1
                                              ? val.rooms.length
                                              : val.rooms.length}
                                          </div>
                                          <a
                                            onClick={() => {
                                              onSelectRoomNo(
                                                val.numberOfRooms + 1,
                                                index,
                                                val.rooms,
                                                getNewRoomGuests(val),
                                                "add",
                                              );
                                            }}
                                          >
                                            <i class="fa-solid fa-plus"></i>
                                          </a>
                                        </div>
                                        {val.rooms.map((room, i) => (
                                          <>
                                            <div
                                              key={i}
                                              className={`d-flex py-2 gap-3 align-items-center ${styles.respCounter}`}
                                            >
                                              <h6>{`Room ${i + 1}:`}</h6>
                                              <div className=" d-flex">
                                                <div className=" d-flex">
                                                  <p
                                                    className={
                                                      styles.titleSubCounter
                                                    }
                                                  >
                                                    Adult:
                                                  </p>
                                                  &nbsp;
                                                  <div
                                                    className={
                                                      styles.subCounter
                                                    }
                                                  >
                                                    <a
                                                      onClick={() =>
                                                        updateGuest(
                                                          index,
                                                          i,
                                                          "adults",
                                                          "minus",
                                                        )
                                                      }
                                                    >
                                                      <i class="fa-solid fa-minus"></i>
                                                    </a>
                                                    <div>
                                                      {room.adults
                                                        ? room.adults
                                                        : 0}
                                                    </div>
                                                    <a
                                                      onClick={() =>
                                                        updateGuest(
                                                          index,
                                                          i,
                                                          "adults",
                                                          "plus",
                                                        )
                                                      }
                                                    >
                                                      <i class="fa-solid fa-plus"></i>
                                                    </a>
                                                  </div>
                                                </div>
                                                <div className=" d-flex">
                                                  <p
                                                    className={
                                                      styles.titleSubCounter
                                                    }
                                                  >
                                                    Children:
                                                  </p>
                                                  &nbsp;
                                                  <div
                                                    className={
                                                      styles.subCounter
                                                    }
                                                  >
                                                    <a
                                                      onClick={() =>
                                                        updateGuest(
                                                          index,
                                                          i,
                                                          "children",
                                                          "minus",
                                                        )
                                                      }
                                                    >
                                                      <i class="fa-solid fa-minus"></i>
                                                    </a>
                                                    <div>
                                                      {room.children
                                                        ? room.children
                                                        : 0}
                                                    </div>

                                                    <a
                                                      onClick={() =>
                                                        updateGuest(
                                                          index,
                                                          i,
                                                          "children",
                                                          "plus",
                                                        )
                                                      }
                                                    >
                                                      <i class="fa-solid fa-plus"></i>
                                                    </a>
                                                  </div>
                                                </div>
                                                <div className=" d-flex">
                                                  <p
                                                    className={
                                                      styles.titleSubCounter
                                                    }
                                                  >
                                                    Infants:
                                                  </p>
                                                  &nbsp;
                                                  <div
                                                    className={
                                                      styles.subCounter
                                                    }
                                                  >
                                                    <a
                                                      onClick={() =>
                                                        updateGuest(
                                                          index,
                                                          i,
                                                          "infants",
                                                          "minus",
                                                        )
                                                      }
                                                    >
                                                      <i class="fa-solid fa-minus"></i>
                                                    </a>
                                                    <div>
                                                      {room.infants
                                                        ? room.infants
                                                        : 0}
                                                    </div>

                                                    <a
                                                      onClick={() =>
                                                        updateGuest(
                                                          index,
                                                          i,
                                                          "infants",
                                                          "plus",
                                                        )
                                                      }
                                                    >
                                                      <i class="fa-solid fa-plus"></i>
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        ))}
                                      </div>
                                    ) : !val?.isAvailable ? (
                                      <div
                                        className={`${styles.addRoomBtn} ${styles.soldOutBtn}`}
                                        aria-disabled="true"
                                      >
                                        Sold Out
                                      </div>
                                    ) : (
                                      <button
                                        type="button"
                                        className={styles.addRoomBtn}
                                        style={{ "--text-color": color }}
                                        {...(index === crawlerRoomIndex
                                          ? criticalPath(1)
                                          : {})}
                                        onClick={() =>
                                          onSelectRoomNo(
                                            1,
                                            index,
                                            val.rooms,
                                            getNewRoomGuests(val),
                                            "add",
                                          )
                                        }
                                      >
                                        Add Room
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <br />{" "}
                          <Modal
                            visible={visible && selectedRoomIndex === index}
                            footer={null}
                            onCancel={closeModal}
                            centered
                            width={800}
                            className="roomPreviewModal"
                            // remount on every open so the slider starts on the clicked photo
                            destroyOnClose
                            title={<b>{modalTitle}</b>}
                          >
                            {selectedRoomIndex !== null && (
                              <div className="carousel slide">
                                <div className="carousel-inner d-flex align-items-center">
                                  <div
                                    className={`d-flex justify-content-between py-4 ${styles.setBtnDiv}`}
                                  >
                                    {/* <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        handlePrevInModal(
                                          selectedImageIndex,
                                          selectedRoomIndex,
                                          singleRoomType?.room_images?.length
                                        )
                                      }
                                    >
                                      <i
                                        style={{
                                          color: "white",
                                          fontSize: "16px",
                                        }}
                                        className="fa-solid fa-chevron-left"
                                      ></i>
                                    </a>

                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        handleNextInModal(
                                          selectedImageIndex,
                                          selectedRoomIndex,
                                          singleRoomType?.room_images?.length
                                        )
                                      }
                                    >
                                      <i
                                        style={{
                                          color: "white",
                                          fontSize: "16px",
                                        }}
                                        className="fa-solid fa-chevron-right"
                                      ></i>
                                    </a> */}
                                  </div>
                                  <Swiper
                                    navigation={true}
                                    modules={[Pagination, Navigation]}
                                    loop={true}
                                    pagination={{ clickable: true }}
                                    slidesPerView={1}
                                    initialSlide={selectedImageIndex}
                                    className="myDetailsSwiper"
                                    ref={swiperRef}
                                  >
                                    {singleRoomType?.room_images?.map(
                                      (item, i) => {
                                        return (
                                          <SwiperSlide key={i}>
                                            {/* same-height frame; empty space around the
                                                photo is filled with a blurred copy of it */}
                                            <div
                                              className={styles.previewFrame}
                                              style={{
                                                "--preview-bg": `url("${
                                                  selectedRoomtype[
                                                    selectedRoomIndex
                                                  ]?.original_room_type
                                                    ?.room_images[i]?.url
                                                }")`,
                                              }}
                                            >
                                              <img
                                                className={`d-block  ${styles.modalCarousel}`}
                                                src={
                                                  selectedRoomtype[
                                                    selectedRoomIndex
                                                  ]?.original_room_type
                                                    ?.room_images[i]?.url
                                                }
                                                alt=""
                                                onClick={() =>
                                                  openModal(
                                                    singleRoomType?.room_ammenties,
                                                    index,
                                                    i,
                                                    `${singleRoomType?.name} ${val?.rate_plan?.rate_name}`,
                                                    singleRoomType?.summary_of_roomtype,
                                                  )
                                                }
                                              />
                                            </div>
                                          </SwiperSlide>
                                        );
                                      },
                                    )}
                                  </Swiper>
                                  <div
                                    className={`carousel-item active ${styles.desCarousel}`}
                                  >
                                    <img
                                      src={
                                        selectedRoomtype[selectedRoomIndex]
                                          ?.original_room_type?.room_images[
                                          selectedImageIndex
                                        ]?.url
                                      }
                                      className={`d-block  ${styles.modalCarousel}`}
                                      alt="Selected Room Image"
                                    />
                                  </div>
                                </div>

                                {/* <ol
                                  className={`carousel-indicators ${styles.customIndicators}`}
                                >
                                  {selectedRoomtype[
                                    selectedRoomIndex
                                  ]?.original_room_type?.room_images?.map(
                                    (item, i) => (
                                      <li
                                        key={item?._id}
                                        className={
                                          i === selectedImageIndex
                                            ? "active"
                                            : ""
                                        }
                                        onClick={() => setSelectedImageIndex(i)}
                                        data-target="#carouselExample"
                                      ></li>
                                    )
                                  )}
                                </ol> */}
                              </div>
                            )}
                            <div className={styles.modalDescription}>
                              <label>
                                <i class="fa-solid fa-hotel"></i> &nbsp;Hotel
                                Services & Amenities
                              </label>

                              <AmenityList
                                amenities={modalAmenities}
                                color={color}
                                className={styles.modalAmenityGrid}
                              />
                              <RoomAbout
                                text={modalRoomDescription}
                                color={color}
                              />
                            </div>
                          </Modal>
                        </div>
                      );
                    }
                  })}
                  {listedRoomTypes.length > 0 && visibleRoomCount === 0 && (
                    <div
                      className={styles.noRoomFit}
                      style={{ "--text-color": color }}
                    >
                      <i class="fa-solid fa-bed"></i>
                      <h4>
                        No single room fits{" "}
                        {guestsLabel(requestedAdults, requestedChildren)}
                      </h4>
                      <p>
                        Show all rooms to see every room type at its maximum
                        occupancy.
                      </p>
                      <div className={styles.noRoomFitActions}>
                        <button
                          type="button"
                          className={styles.showAllBtn}
                          onClick={() => setShowAllRooms(true)}
                        >
                          Show all rooms
                        </button>
                      </div>
                    </div>
                  )}
                  {hiddenRoomCount > 0 && visibleRoomCount > 0 && (
                    <p className={styles.hiddenRoomsNote}>
                      {hiddenRoomCount}{" "}
                      {hiddenRoomCount === 1
                        ? "room type is"
                        : "room types are"}{" "}
                      hidden because{" "}
                      {hiddenRoomCount === 1 ? "it fits" : "they fit"} fewer
                      than {guestsLabel(requestedAdults, requestedChildren)} per
                      room.{" "}
                      <a onClick={() => setShowAllRooms(true)}>
                        Show all rooms
                      </a>
                    </p>
                  )}
                  {showAllRooms &&
                    fittingRoomCount < listedRoomTypes.length && (
                      <p className={styles.hiddenRoomsNote}>
                        Showing all rooms.{" "}
                        <a onClick={() => setShowAllRooms(false)}>
                          Only show rooms that fit{" "}
                          {guestsLabel(requestedAdults, requestedChildren)}
                        </a>
                      </p>
                    )}
                </div>
              )}
            </div>
            {overBookingModal && (
              <Modal
                title="Maximum Availability Reached"
                visible={overBookingModal}
                onCancel={closeOverBookingModal}
                footer={[
                  <Button
                    key="ok"
                    type="primary"
                    onClick={closeOverBookingModal}
                    style={{
                      backgroundColor: "#2c2a25",
                      borderColor: "#2c2a25",
                      color: "#ffffff",
                    }}
                  >
                    OK
                  </Button>,
                ]}
              >
                <p>
                  You’ve selected the maximum available rooms for this room
                  type. To book additional rooms, please choose another room
                  type or modify your selection.
                </p>
              </Modal>
            )}

            {hasSelectedRooms && (
              <div className={`col-12 col-md-12 col-lg-4 ${styles.cartColumn}`}>
                <ViewCart
                  reservationStartDate={reservationStartDate}
                  reservationEndDate={reservationEndDate}
                  selectedRoomtype={selectedRoomtype.filter(
                    (val) => val.numberOfRooms > 0,
                  )}
                  numberOfNights={numberOfNights}
                  rsSymbol={rsSymbol}
                  setShowBill={setShowBill}
                  showBill={showBill}
                  customerData={customerData}
                  currentRegisterData={currentRegisterData}
                  reservationDisable={reservationDisable}
                  setSelectedRoomType={setSelectedRoomType}
                  onRemoveRoomType={removeRoomTypeFromCart}
                  shopDetails={shopDetails}
                  setReservationData={setReservationData}
                  setShowBill1={setShowBill1}
                  showBill1={showBill1}
                  paymentType={paymentType}
                  currency={currency}
                  custom_payment={custom_payment}
                  color={color}
                />
              </div>
            )}
            {showBill && windowWidth <= 1024 && (
              <div>
                <br></br>
                <Customer
                  setCustomerData={setCustomerData}
                  customerData={customerData}
                  cancelPolicy={cancelPolicy}
                  privacyPolicy={privacyPolicy}
                  termCondtion={termCondtion}
                />
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default BookingDetails;
